import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';

import { receiveError } from '../../../store/actions/notificationAction';

import pickupOrderRemote from '../../../api/pickupOrderRemote';

import ApiResponse from '../../../models/ApiResponse';
import ResponseError from '../../../models/ResponseError';
import WhsOrderAwbWeight from './WhsOrderAwbWeight';
import GhaPickupStatus from '../../../models/GhaPickupStatus';
import GhaPickupStatusAwb from '../../../models/GhaPickupStatusAwb';
import { PO_AWB_SCHEMA } from '../../../utils/pickupOrder';
import Dimension from '../../../models/Dimension';
import ConfirmationDialog from '../../confirmation/ConfirmationDialog';
import { OrderLockStatusType } from '../../../models/OrderLockStatusType.enum';
import OrderWhsDetails from '../../../models/OrderWhsDetails';

interface WhsOrderAwbWeightContainerProps {
  history: { push: Function; };
  match: { isExact: boolean; params: { awbCode: string; awbNumber: string; awbVersion: string; orderNumber: string }; path: string; url: string; };
  location: any;
  receiveError: Function;
};
  
interface WhsOrderAwbWeightContainerState {
  selectedAwb: string;
  orderAwb: GhaPickupStatusAwb;
  currentDimension: Dimension;
  calculatedCWT: number;
  calculatedScaleWeight: number;
  saveConfirmationOpen: boolean;
  exitConfirmationOpen: boolean;
  isTableDataChanged: boolean;
  exceededPiecesConfirmationOpen: boolean;
  onlyRead: boolean;
  weightType: string;
  order: { 
    lock_status: string,
    gha_wh_user_name: string
  }
};

class WhsOrderAwbWeightContainer extends Component<WhsOrderAwbWeightContainerProps, WhsOrderAwbWeightContainerState> {

  state = {
    selectedAwb: '',
    orderAwb: PO_AWB_SCHEMA,
    weightType: 'auto',
    calculatedScaleWeight: 0,
    currentDimension: {
      length: 0,
      width: 0,
      height: 0,
      pieces: 0,
      weightPc: 0,
      totalWeight: 0
    },
    calculatedCWT: 0,
    saveConfirmationOpen: false,
    exitConfirmationOpen: false,
    isTableDataChanged: false,
    exceededPiecesConfirmationOpen: false,
    onlyRead: false,
    order: {
      lock_status: '',
      gha_wh_user_name: '',
      driver_signature_key: ''
    }
  }
  
  componentDidMount() {
    const orderNumber: string = this.props.match.params.orderNumber;
    const awbCode: string = this.props.match.params.awbCode;
    const awbNumber: string = this.props.match.params.awbNumber;
    const awbVersion: number = Number(this.props.match.params.awbVersion);

    if(this.props.location.state) {
      const onlyRead = this.props.location.state.onlyRead;
      this.setState({ onlyRead })
     
    }

    pickupOrderRemote.getGhaPoAwb(orderNumber, awbCode, awbNumber, awbVersion).then((resp: ApiResponse<GhaPickupStatus>) => {

      const order: GhaPickupStatus | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;

      if (order) {
        this.setState({ selectedAwb: awbCode + '-' + awbNumber, orderAwb: order.po_awb });
        this.calculateCWT(order.po_awb.cwt_data);

        pickupOrderRemote.getPickupOrderWhs(orderNumber).then((resp: ApiResponse<OrderWhsDetails>) => {

          const order: OrderWhsDetails | undefined = resp.result;
          const error: ResponseError | undefined = resp.error;
    
          if (order) {
            
            this.setState({ order });
    
            if(!this.state.order.driver_signature_key) {
              this.doLockPickupOrder();
            }
          }
    
          if (error) {
            this.props.receiveError(error);
          };
        });
      }

      if (error) {
        this.props.receiveError(error);
      };
    });
  }

  componentWillUnmount() {

    if(!this.state.order.driver_signature_key) {
      this.doLockPickupOrder();
    }
  }

  changeCalculationType = (event: any): void => {
    const value = event.target.value;
    let actualWeight: number = 0;
    let orderAwb: GhaPickupStatusAwb = {... this.state.orderAwb};
    if(value === 'manual') {
      orderAwb.actual_scale_weight = '';
    } else {
      orderAwb.cwt_data.data.forEach((pc: Dimension) => {
        actualWeight += pc.totalWeight;
      });
      orderAwb.actual_scale_weight = actualWeight.toString();
    }
    this.setState({ weightType: value, orderAwb });
  }

  doLockPickupOrder = (): void => {

    const locked: boolean = this.state.order.lock_status === OrderLockStatusType.UNLOCKED;
    const number: string = this.props.match.params.orderNumber;

    if(number) {
      pickupOrderRemote.doGhaWhPoLock(number, locked).then((resp: ApiResponse<{ lock_status: string; gha_wh_user_name: string; }>) => {

        const updateValues: { lock_status: string; gha_wh_user_name: string; } | undefined = resp.result;
        const error: ResponseError | undefined = resp.error;
  
        if (updateValues) {
          const order = { ...this.state.order };
  
          order.lock_status = updateValues.lock_status;
          order.gha_wh_user_name = updateValues.gha_wh_user_name;
  
          this.setState({ order });
        }
    
        if (error) {
          this.props.receiveError(error);
        };
      });
    }
    
  }

  handleChange = (name: string) => (event: any): void => {
    let orderAwb = {... this.state.orderAwb};
    let currentDimension = {... this.state.currentDimension};
    const rawValue = event.target.value;
    const numericValue = Number(rawValue);
    const isDimOrWeightField = ['height', 'length', 'width', 'pieces', 'weight', 'actualWeightScale'].indexOf(name) !== -1;

    // Block negative dims/weight (allow empty while typing)
    if (isDimOrWeightField && rawValue !== '' && (isNaN(numericValue) || numericValue < 0)) {
      return;
    }

    switch(name) {
      case 'measurementUnit': 
        orderAwb.cwt_data.measurement_unit = event.target.value;
        break;
      case 'height': 
        currentDimension.height = numericValue;
        break;
      case 'length': 
        currentDimension.length = numericValue;
        break;
      case 'width': 
        currentDimension.width = numericValue;
        break;
      case 'pieces': 
        currentDimension.pieces = numericValue;
        break;
      case 'weight': 
        currentDimension.weightPc = numericValue;
        break;
      case 'actualWeightScale': 
        // TODO: This is quite hacky
        if (rawValue.split(".").length - 1 > 1) { // If more than one dot
          break;
        }
        let lastIsDot = rawValue[rawValue.length - 1] == '.';
        let valueForNumber = lastIsDot ? rawValue.substring(0, rawValue.length - 1) : rawValue;
        if (valueForNumber !== '' && (isNaN(Number(valueForNumber)) || Number(valueForNumber) < 0)) {
          break;
        }
        let newAsw = Number(valueForNumber).toString();
        orderAwb.actual_scale_weight = newAsw != 'NaN'? newAsw: orderAwb.actual_scale_weight;
        if (lastIsDot) {
          orderAwb.actual_scale_weight += '.';
        }
        break;
      default: break;
    }
    this.setState({ orderAwb, currentDimension });
  }

  addRow = () => {
    let orderAwb: GhaPickupStatusAwb = {... this.state.orderAwb};
    let actualWeight: number = 0;
    const currentDimension: Dimension = {... this.state.currentDimension};
    const defaultDimension: Dimension =  {
      length: 0,
      width: 0,
      height: 0,
      pieces: 0,
      weightPc: 0,
      totalWeight: 0
    };

    const hasNegativeDim =
      currentDimension.length < 0 ||
      currentDimension.height < 0 ||
      currentDimension.width < 0 ||
      currentDimension.pieces < 0 ||
      currentDimension.weightPc < 0;

    if (hasNegativeDim) {
      return;
    }

    if (currentDimension.length && currentDimension.height && currentDimension.width && currentDimension.pieces) {
      if (orderAwb.pieces < this.piecesSum() + currentDimension.pieces) {
        this.openExceededPiecesConfirmation();
      } else {
        currentDimension.totalWeight = currentDimension.pieces * currentDimension.weightPc;
        orderAwb.cwt_data.data.push(currentDimension);
        orderAwb.cwt_data.data.forEach((pc: Dimension) => {
          actualWeight += pc.totalWeight;
        });
        orderAwb.actual_scale_weight = actualWeight.toString();
        this.setState({ orderAwb, currentDimension: defaultDimension, calculatedScaleWeight: actualWeight, isTableDataChanged: true });
        this.calculateCWT(orderAwb.cwt_data);
      }
      this.save(true);
    }
  }

  setOrderAwb = (orderAwb: GhaPickupStatusAwb): void => {
    let actualWeight: number = 0;
    if(this.state.weightType === 'auto') {
      orderAwb.cwt_data.data.forEach((pc: Dimension) => {
        actualWeight += pc.totalWeight;
      });
      orderAwb.actual_scale_weight = actualWeight.toString();
    }
    this.setState({orderAwb, isTableDataChanged: true});
    this.calculateCWT(orderAwb.cwt_data);
  };

  calculateCWT = (cwtData: {data: Array<Dimension>, measurement_unit: string}): void => {
    pickupOrderRemote.calculateCWT(cwtData).then((resp: ApiResponse<{cwt: number}>) => {
      const result: {cwt: number} | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;

      if (result) {
        this.setState({calculatedCWT: Number(result.cwt.toFixed(1))});
      }

      if (error) {
        this.props.receiveError(error);
      };
    });
  }

  save = (redirect?: boolean): void => {
    const orderNumber: string = this.props.match.params.orderNumber;
    const awbCode: string = this.props.match.params.awbCode;
    const awbNumber: string = this.props.match.params.awbNumber;

    pickupOrderRemote.saveCWTData(orderNumber, awbCode, awbNumber, this.state.orderAwb.cwt_data, this.state.orderAwb.actual_scale_weight).then((resp: ApiResponse<boolean>) => {
      const result: boolean | undefined = resp.success;
      const error: ResponseError | undefined = resp.error;

      if (result) {
        this.setState({isTableDataChanged: false});
        if(!redirect) {
          if (this.state.orderAwb.pieces > this.piecesSum()) {
            this.setState({saveConfirmationOpen: true});
          } else {
            this.redirectToDO();
          }
        }
      
      }

      if (error) {
        this.props.receiveError(error);
      };
    })
  }

  exit = (): void => {
    if (this.state.isTableDataChanged) {
      this.setState({exitConfirmationOpen: true});
    } else {
      this.redirectToDO();
    }
  }

  redirectToDO = (): void => {
    const orderNumber: string = this.props.match.params.orderNumber;
    this.props.history.push(`/whs/do/${orderNumber}`);
  }

  piecesSum = (): number => {
    let result: number = 0;
    this.state.orderAwb.cwt_data.data.forEach((item: Dimension) => {
      result += item.pieces;
    });
    return result;
  }

  openExceededPiecesConfirmation = (): void => {
    this.setState({exceededPiecesConfirmationOpen: true});
  }

  closeExceededPiecesConfirmation = (): void => {
    this.setState({exceededPiecesConfirmationOpen: false}, (): void => {
      let addPcsInput: HTMLElement | null = document.querySelector('[placeholder="Pcs"]');
      
      if (this.state.currentDimension.pieces) {
        addPcsInput = document.getElementById('addPcsInput');
      }

      if (addPcsInput) {
        addPcsInput.focus();
      }
    });

  }

  render() {
    return (
      <>
        <Fragment>
          <WhsOrderAwbWeight
            awbNumber={ this.state.selectedAwb }
            save={ this.save }
            exit={ this.exit }
            orderAwb={this.state.orderAwb}
            handleChange={this.handleChange}
            currentDimension={this.state.currentDimension}
            addRow={this.addRow}
            setOrderAwb={ this.setOrderAwb }
            calculatedCWT={this.state.calculatedCWT}
            openExceededPiecesConfirmation={this.openExceededPiecesConfirmation}
            onlyRead={ this.state.onlyRead }
            weightType={ this.state.weightType }
            calculationChange={ this.changeCalculationType }
          />
          { this.state.saveConfirmationOpen &&
            <ConfirmationDialog
              open={ this.state.saveConfirmationOpen }
              title=''
              text='You have not recorded all pieces, do you wish to exit?'
              close={() => { this.setState({ saveConfirmationOpen: false }) }}
              confirm={ this.redirectToDO }
              textConfirm='OK'
              showCloseIcon={ true }
            /> 
          }
          { this.state.exitConfirmationOpen &&
            <ConfirmationDialog
              open={ this.state.exitConfirmationOpen }
              title=''
              text='Data you have entered will not be saved, do you wish to poroceed?'
              close={() => { this.setState({ exitConfirmationOpen: false }) }}
              confirm={ this.redirectToDO }
              textConfirm='OK'
              showCloseIcon={ true }
            /> 
          }
          { this.state.exceededPiecesConfirmationOpen &&
            <ConfirmationDialog
              open={ this.state.exceededPiecesConfirmationOpen }
              title=''
              text='You have exceeded the total pieces of this airwaybill, please correct your input!'
              close={ this.closeExceededPiecesConfirmation }
              confirm={ this.closeExceededPiecesConfirmation }
              textConfirm='OK'
              showCloseIcon={ true }
            /> 
          }
        </Fragment>
      </>
    )
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    receiveError: (error: ResponseError) => dispatch(receiveError(error))
  };
};
  
export default connect(null, mapDispatchToProps)(WhsOrderAwbWeightContainer);